function initAllProductReels() {
  document.querySelectorAll('.product-reels-swiper').forEach(function (rootEl) {
    if (rootEl.dataset.reelsInit) return;
    rootEl.dataset.reelsInit = 'true';
    initProductReels(rootEl);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllProductReels);
} else {
  initAllProductReels();
}

function initProductReels(rootEl) {
  var track = rootEl.querySelector('.swiper-wrapper');
  if (!track) return;

  var cartCache = null;
  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  // On metered/slow connections, don't auto-download video at all — leave the
  // poster frame showing and let the user opt in via the existing tap-to-play
  // controls (initSlideControls' pauseBtn/video click handlers).
  var netInfo = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
  var isDataSaver = !!(netInfo && (netInfo.saveData || /^(slow-2g|2g)$/.test(netInfo.effectiveType)));

  var realSlides = Array.prototype.slice.call(track.children);
  var realCount = realSlides.length;
  if (realCount === 0) return;

  // ── Build loop clones ───────────────────────────────────────────────────────
  // Prepend clones of the last CLONE_COUNT real slides, append clones of the
  // first CLONE_COUNT real slides — the standard scroll-snap infinite-loop
  // illusion. A scroll listener below silently (no animation) jumps back to
  // the equivalent real slide the moment one of these clones settles as active,
  // so the clone is only ever visible for the split-second of the gesture itself.
  // Looping only makes sense once there's meaningfully more content than fits
  // on screen at once — a flat "more than 2 real slides" threshold isn't
  // enough: at wide desktop breakpoints, 4-5 slides can be visible
  // simultaneously (see the width breakpoints in component-product-reels.css),
  // so e.g. realCount === 3 there still only has 3 real slides to fill 3
  // clones on each side. The track (9 slides total) barely exceeds the
  // container's width, leaving almost no real scroll room — nav buttons
  // appear to do nothing, and centerSlide() can land on a run mostly made of
  // clones of the same 1-2 products, reading as duplicated content instead
  // of a clean centered set. Measuring how many slides actually fit at once
  // and requiring real slides to comfortably exceed that (by 2, so there's
  // always at least one clone's worth of buffer on each side) avoids both.
  var trackGap = parseFloat(getComputedStyle(track).columnGap) || 0;
  var sampleWidth = realSlides[0].getBoundingClientRect().width;
  var visibleSlideCount = sampleWidth > 0 ? Math.ceil(track.clientWidth / (sampleWidth + trackGap)) : 1;
  var CLONE_COUNT = realCount >= visibleSlideCount + 2 ? Math.min(3, realCount) : 0;
  var REAL_START = CLONE_COUNT;
  var REAL_END = CLONE_COUNT + realCount - 1;

  if (CLONE_COUNT === 0 && track.scrollWidth <= track.clientWidth + 1) {
    // Real slides alone can still slightly overflow the container even
    // without enough content to justify looping (e.g. exactly one more
    // slide than fits). justify-content: center on overflowing flex content
    // is unreliable — the overflowed start can become unreachable by scroll
    // in some browsers — so only center when the row truly fits with no
    // overflow. Otherwise leave it as a plain scrollable (non-looping) row.
    // Nav button visibility is decided purely by realCount further down,
    // independent of whether this centering applies.
    track.classList.add('reel-track--static');
  }

  function makeClone(realSlide) {
    var clone = realSlide.cloneNode(true);
    clone.classList.add('reel-clone');
    clone.setAttribute('aria-hidden', 'true');
    // Cloned nodes duplicate every id in the subtree (variant <select>, ATC
    // <button>) — strip them so the page never has two elements sharing an id.
    clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    return clone;
  }

  if (CLONE_COUNT > 0) {
    var frag = document.createDocumentFragment();
    for (var h = realCount - CLONE_COUNT; h < realCount; h++) {
      frag.appendChild(makeClone(realSlides[h]));
    }
    realSlides.forEach(function (s) { frag.appendChild(s); });
    for (var t = 0; t < CLONE_COUNT; t++) {
      frag.appendChild(makeClone(realSlides[t]));
    }
    track.innerHTML = '';
    track.appendChild(frag);
  }

  var allSlides = Array.prototype.slice.call(track.children);

  // Video posters aren't lazy-loaded by the browser like <img loading="lazy"> —
  // a static poster attribute on every slide fetches all of them immediately,
  // regardless of preload="none" on the <video> itself. Apply it via JS instead.
  // Tied to actual on-screen visibility (see initPosterVisibility below), NOT to
  // the active ± 1 video-load window — several slides are visible at once, and
  // any visible-but-not-active slide would otherwise show a plain black
  // <video> box (no frame decoded, no poster) until it becomes active.
  function applyPoster(slide) {
    var video = slide && slide.querySelector('[data-reel-video]');
    if (!video || video.poster || !video.dataset.poster) return;
    // Posters have no srcset/sizes equivalent — request one sized to this
    // slide's actual current width (which varies by breakpoint via CSS)
    // instead of a single flat guess.
    var targetWidth = Math.round((slide.clientWidth || 300) * (window.devicePixelRatio || 1));
    targetWidth = Math.min(Math.max(targetWidth, 200), 900);
    try {
      var url = new URL(video.dataset.poster, window.location.origin);
      url.searchParams.set('width', String(targetWidth));
      video.poster = url.toString();
    } catch (e) {
      video.poster = video.dataset.poster;
    }
  }

  // Applies posters to whichever slides are actually visible in the carousel's
  // viewport (not just the active one), so peeking neighbors never show black.
  function initPosterVisibility() {
    if ('IntersectionObserver' in window) {
      var posterIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            applyPoster(entry.target);
            posterIo.unobserve(entry.target);
          }
        });
      }, { root: track, rootMargin: '100px', threshold: 0.01 });
      allSlides.forEach(function (slide) { posterIo.observe(slide); });
    } else {
      allSlides.forEach(function (slide) { applyPoster(slide); });
    }
  }

  // ── Video source load/unload ────────────────────────────────────────────────
  // No <source> is rendered in the Liquid template at all (see data-video-src on
  // the <video> tag) — only the active slide + one neighbor on each side ever get
  // a real <source> appended, and it's removed again once a slide scrolls outside
  // that window. Clones carry the same data-video-src attributes (cloneNode
  // copies them), so this logic covers real and cloned slides identically.

  // Connection-aware quality ceiling. Re-read at every load call (not cached)
  // since effectiveType/innerWidth can change between slides (rotation, a
  // throttled connection recovering, etc).
  function getMaxAllowedHeight() {
    var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    var saveData = !!(conn && conn.saveData);
    var effectiveType = conn && conn.effectiveType;
    if (saveData || effectiveType === 'slow-2g' || effectiveType === '2g') return 240;
    if (effectiveType === '3g' || window.innerWidth < 750) return 360;
    return 480;
  }

  // Picks the data-src-* tier matching the connection ceiling, falling back
  // upward (240 -> 360 -> 480) when a lower tier's attribute is absent — that
  // only happens when product-reel-items.liquid found it identical to the next
  // tier up and omitted the duplicate, so the fallback is always the same file.
  function pickVideoSrc(video) {
    var maxHeight = getMaxAllowedHeight();
    if (maxHeight <= 240) return video.dataset.src240 || video.dataset.src360 || video.dataset.videoSrc;
    if (maxHeight <= 360) return video.dataset.src360 || video.dataset.videoSrc;
    return video.dataset.videoSrc;
  }

  function loadReelVideo(slide) {
    var video = slide && slide.querySelector('[data-reel-video]');
    if (!video || video.dataset.videoLoaded === 'true') return;
    var src = pickVideoSrc(video);
    if (!src) return;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.preload = 'auto';
    video.load();
    video.dataset.videoLoaded = 'true';
  }

  function unloadReelVideo(slide) {
    var video = slide && slide.querySelector('[data-reel-video]');
    if (!video || video.dataset.videoLoaded !== 'true') return;
    video.pause();
    video.querySelectorAll('source').forEach(function (s) { s.remove(); });
    video.removeAttribute('src');
    video.preload = 'none';
    video.load();
    delete video.dataset.videoLoaded;
  }

  // Loads active ± 1, unloads everything else. Pure resource management — does
  // NOT decide whether to autoplay (that stays gated by supportsHover/isDataSaver
  // at the call sites below, matching the existing hover-to-play desktop UX).
  function syncActiveVideoWindow() {
    var keep = [activeIndex - 1, activeIndex, activeIndex + 1];
    allSlides.forEach(function (slide, i) {
      if (keep.indexOf(i) !== -1) {
        loadReelVideo(slide);
      } else {
        unloadReelVideo(slide);
      }
    });
  }

  // Attach pause / mute listeners directly on every button in a slide.
  // Direct listeners (not delegation) ensure the browser treats video.play()
  // as a real user gesture so audio unlocks correctly.
  function initSlideControls(slide) {
    if (slide._ctrlInit) return;
    slide._ctrlInit = true;

    var video     = slide.querySelector('[data-reel-video]');
    var pauseBtn  = slide.querySelector('.reel-center-play');
    var muteBtn   = slide.querySelector('.mute-btn');
    var shareBtn  = slide.querySelector('.share-btn');
    var container = slide.querySelector('.reel-media');

    if (!video) return;

    // Center play button mirrors the video's real play/pause state via these
    // events — not set manually at each call site — so a silently-blocked/
    // failed autoplay (e.g. restrictive in-app browsers) still leaves the
    // "tap to play" affordance visible instead of hiding it over a frozen frame.
    if (pauseBtn && container) {
      video.addEventListener('play', function () {
        container.classList.add('is-playing');
        pauseBtn.setAttribute('aria-label', 'Pause video');
      });
      video.addEventListener('pause', function () {
        container.classList.remove('is-playing');
        pauseBtn.setAttribute('aria-label', 'Play video');
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        var url   = shareBtn.dataset.shareUrl || window.location.href;
        var title = shareBtn.dataset.shareTitle || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            showCartToast('Link copied!');
          }).catch(function () {});
        }
      });
    }

    // Show the spinner whenever playback stalls waiting for data (including the
    // very first play attempt right after loadReelVideo() injects the source),
    // hide it once frames actually start rendering.
    if (container) {
      video.addEventListener('waiting', function () { container.classList.add('is-buffering'); });
      video.addEventListener('playing', function () { container.classList.remove('is-buffering'); });
      video.addEventListener('canplay', function () { container.classList.remove('is-buffering'); });
      video.addEventListener('error', function () { container.classList.remove('is-buffering'); });
      video.addEventListener('pause', function () { container.classList.remove('is-buffering'); });
    }

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (video.paused) {
          loadReelVideo(slide);
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        var nowMuted = !video.muted;
        video.muted = nowMuted;
        if (!nowMuted) {
          video.removeAttribute('muted');
          video.volume = 1;
        }
        // play() called directly from this click — browser grants audio
        video.play().catch(function () {});
        muteBtn.querySelector('.muted-icon').style.display   = nowMuted ? 'block' : 'none';
        muteBtn.querySelector('.unmuted-icon').style.display = nowMuted ? 'none'  : 'block';
      });
    }

    video.addEventListener('click', function (e) {
      if (e.target.closest('.video-controls') || e.target.closest('.reel-product-card') || e.target.closest('.reel-center-play')) return;
      if (video.paused) {
        loadReelVideo(slide);
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    if (supportsHover) {
      slide.addEventListener('mouseenter', function () {
        allSlides.forEach(function (s) {
          var v = s.querySelector('[data-reel-video]');
          if (v && v !== video) v.pause();
        });
        // A hovered slide can be a "peeking" neighbor outside the active ± 1
        // load window, so make sure it actually has a source before playing.
        loadReelVideo(slide);
        video.play().catch(function () {});
      });

      slide.addEventListener('mouseleave', function () {
        video.pause();
      });
    }
  }

  allSlides.forEach(function (slide) { initSlideControls(slide); });
  initPosterVisibility();

  // ── Active-slide tracking (replaces Swiper's activeIndex/slideChange) ───────
  // rootMargin shrinks the observed region to a thin vertical strip at the
  // container's horizontal center, so exactly one slide — whichever is
  // scroll-snapped into that center — ever counts as "intersecting",
  // regardless of how wide slides are relative to the container (unlike a
  // flat intersection-ratio threshold, which gets ambiguous when two slides
  // are both mostly visible at once on narrow viewports).
  var activeIndex = REAL_START + Math.floor(realCount / 2);

  function setActiveClasses(idx) {
    allSlides.forEach(function (slide, i) {
      slide.classList.toggle('swiper-slide-active', i === idx);
      slide.classList.toggle('swiper-slide-prev', i === idx - 1);
      slide.classList.toggle('swiper-slide-next', i === idx + 1);
    });
  }

  function setActive(idx) {
    if (idx === activeIndex) return;
    activeIndex = idx;
    setActiveClasses(activeIndex);
    allSlides.forEach(function (v) {
      var video = v.querySelector('[data-reel-video]');
      if (video) video.pause();
    });
    // Synchronous, ahead of the async IntersectionObserver callbacks below,
    // so the active slide's poster/source are never a tick behind the switch.
    applyPoster(allSlides[activeIndex]);
    syncActiveVideoWindow();

    if (!supportsHover) {
      var activeSlide = allSlides[activeIndex];
      var video = activeSlide && activeSlide.querySelector('[data-reel-video]');
      if (video) {
        video.muted = true;
        video.currentTime = 0;
        video.play().catch(function () {});
        var muteBtn = activeSlide.querySelector('.mute-btn');
        if (muteBtn) {
          muteBtn.querySelector('.muted-icon').style.display   = 'block';
          muteBtn.querySelector('.unmuted-icon').style.display = 'none';
        }
      }
    }
  }

  function unitWidth() {
    if (allSlides.length < 2) return 0;
    var a = allSlides[REAL_START] || allSlides[0];
    var b = allSlides[REAL_START + 1] || allSlides[1];
    return b.offsetLeft - a.offsetLeft;
  }

  // Ground truth for "which slide is centered right now", computed straight
  // from scroll geometry rather than trusted from whatever the
  // IntersectionObserver last reported — a font swap, image load, or any
  // other layout shift can move slides without necessarily re-firing (and
  // resolving correctly through) an IO callback, so anything correction-
  // critical re-derives this fresh instead of relying on stale state.
  function closestSlideIndex() {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestDist = Infinity;
    allSlides.forEach(function (slide, i) {
      var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
      var dist = Math.abs(slideCenter - center);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  // ── Loop illusion: silently correct once scrolling settles on a clone ───────
  var scrollSettleTimer = null;
  function correctLoopPosition() {
    if (CLONE_COUNT === 0) return;
    var idx = closestSlideIndex();
    if (idx < REAL_START) {
      // Jump by the exact measured distance between this clone and its real
      // counterpart (not realCount * an assumed-uniform unitWidth) — avoids
      // any sub-pixel rounding drift accumulating across many slides.
      var realEquivalent = idx + realCount;
      track.scrollLeft += allSlides[realEquivalent].offsetLeft - allSlides[idx].offsetLeft;
      setActive(realEquivalent);
    } else if (idx > REAL_END) {
      var realEquivalentBack = idx - realCount;
      track.scrollLeft -= allSlides[idx].offsetLeft - allSlides[realEquivalentBack].offsetLeft;
      setActive(realEquivalentBack);
    } else if (idx !== activeIndex) {
      // Not in clone territory, but drifted from what we last recorded —
      // e.g. a layout shift moved slides without the IO catching it.
      setActive(idx);
    }
  }

  // 'scrollend' (where supported) fires only once scrolling — including
  // touch-momentum coasting, which can run several hundred ms past the
  // finger lifting on mobile — has genuinely finished. A fixed debounce
  // was firing mid-momentum on mobile, so the correction's programmatic
  // scrollLeft jump fought the browser's still-active inertial scroll,
  // producing exactly the "glitch after swiping past the loop boundary"
  // symptom seen on real devices. Debounce is kept only as a fallback for
  // browsers without 'scrollend' (older Safari).
  if ('onscrollend' in window) {
    track.addEventListener('scrollend', correctLoopPosition, { passive: true });
  } else {
    track.addEventListener('scroll', function () {
      if (scrollSettleTimer) clearTimeout(scrollSettleTimer);
      scrollSettleTimer = setTimeout(correctLoopPosition, 200);
    }, { passive: true });
  }

  // ── Initial position: center the same "middle-ish" slide Swiper used to ────
  // Deliberately NOT using Element.scrollIntoView() here: even with
  // block:'nearest', it scrolls every scrollable ancestor needed to bring
  // the target into view — including the page itself, if the carousel isn't
  // already fully in the viewport when this runs (true on every page
  // load/reload before the user has scrolled down to it). That was yanking
  // the whole page down to the reel section on load. track.scrollLeft /
  // track.scrollTo() are scoped to just this one element and never touch
  // the page's scroll position.
  function centerSlide(idx, smooth) {
    var slide = allSlides[idx];
    if (!slide) return;
    var target = slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    if (smooth) {
      track.scrollTo({ left: target, behavior: 'smooth' });
    } else {
      // A large instant jump (e.g. from scrollLeft:0 straight to a middle
      // slide) can conflict with scroll-snap-type: x mandatory — some
      // browsers only honor the nearest snap point for an instant jump
      // instead of the exact target. Suspending snap for the jump avoids that.
      track.style.scrollSnapType = 'none';
      track.scrollLeft = target;
      // eslint-disable-next-line no-unused-expressions
      track.offsetHeight; // force layout flush before restoring snap
      track.style.scrollSnapType = '';
    }
  }
  centerSlide(activeIndex, false);
  setActiveClasses(activeIndex);
  syncActiveVideoWindow();

  // Start observing only after the initial scroll position is set — an
  // IntersectionObserver's first callback reflects whatever is intersecting
  // at the moment it actually fires (not at .observe()-call time), but
  // starting it before the page has scrolled to the intended slide leaves a
  // window where an early callback can catch the pre-scroll (near clone-zone)
  // state and incorrectly latch onto it.
  var activeIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var idx = allSlides.indexOf(entry.target);
      if (idx !== -1) setActive(idx);
    });
  }, { root: track, rootMargin: '0px -45% 0px -45%', threshold: 0 });
  allSlides.forEach(function (slide) { activeIo.observe(slide); });

  // Re-verify (and re-center/re-correct if needed) after layout has had every
  // chance to settle — webfont swaps, poster images, and other async layout
  // shifts can all move slide positions enough that the scroll position set
  // above no longer matches the slide it was centered on when this ran.
  function resettle() {
    centerSlide(activeIndex, false);
    correctLoopPosition();
  }
  requestAnimationFrame(function () { requestAnimationFrame(resettle); });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(resettle);
  }
  window.addEventListener('load', resettle, { once: true });

  // Viewport-visibility autoplay for touch devices — same intent as before:
  // don't force the (possibly multi-MB) active video to start downloading
  // just because the page loaded; wait until the section actually scrolls
  // into view, and pause everything again once it scrolls back out.
  if (!supportsHover && !isDataSaver) {
    var playActiveVideo = function () {
      var video = allSlides[activeIndex] && allSlides[activeIndex].querySelector('[data-reel-video]');
      if (video) video.play().catch(function () {});
    };
    var pauseAllVideos = function () {
      allSlides.forEach(function (s) {
        var v = s.querySelector('[data-reel-video]');
        if (v) v.pause();
      });
    };
    if ('IntersectionObserver' in window) {
      var visIo = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          playActiveVideo();
        } else {
          pauseAllVideos();
        }
      }, { rootMargin: '200px' });
      visIo.observe(rootEl);
    } else {
      playActiveVideo();
    }
  }

  // ── Nav buttons ──────────────────────────────────────────────────────────────
  // Shown whenever there's more than one real slide to navigate to, whether
  // or not looping is active. With looping (CLONE_COUNT > 0) there's always
  // another slide to scroll to. Without it, scrollBy() past the first/last
  // real slide simply clamps to the track's actual scroll range — no
  // wraparound, no error, it just stays put, which is the desired behavior.
  //
  // When every real slide already fits in the container at once (the
  // reel-track--static case — centered via CSS, nothing to scroll), scrollBy()
  // has no range to move within at all, so it would silently do nothing.
  // There's still a meaningful "next/prev" there though: which slide is the
  // prominent, scaled-up "active" one. Advance that directly via setActive()
  // in that case instead of trying to scroll.
  function goToAdjacentSlide(direction) {
    var maxScrollLeft = track.scrollWidth - track.clientWidth;
    if (maxScrollLeft > 1) {
      track.scrollBy({ left: direction * unitWidth(), behavior: 'smooth' });
    } else {
      var next = activeIndex + direction;
      if (next < REAL_START) next = REAL_START;
      if (next > REAL_END) next = REAL_END;
      setActive(next);
    }
  }
  var prevBtn = rootEl.querySelector('.reel-nav-prev');
  var nextBtn = rootEl.querySelector('.reel-nav-next');
  if (realCount <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { goToAdjacentSlide(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToAdjacentSlide(1); });

  // ── Keyboard navigation ──────────────────────────────────────────────────────
  // Matches Swiper's default keyboard module behavior: arrow keys act on the
  // nearest carousel currently scrolled into the viewport, without requiring
  // the user to first click/focus anything inside it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tag = document.activeElement && document.activeElement.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    var rect = rootEl.getBoundingClientRect();
    var inView = rect.bottom > 0 && rect.top < window.innerHeight;
    if (!inView) return;
    e.preventDefault();
    goToAdjacentSlide(e.key === 'ArrowLeft' ? -1 : 1);
  });

  // ── Add to cart (capture phase) ──────────────────────────────────────────────

  rootEl.addEventListener('click', async function (e) {
    var addBtn = e.target.closest('.reel-atc-button');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var form = addBtn.closest('.reel-product-form');
    if (!form) return;

    var selectWrap  = form.querySelector('.reel-variant-select');
    var selectInput = form.querySelector("select[name='id']");
    var hiddenInput = form.querySelector("input[name='id']");

    if (selectInput && selectWrap && selectWrap.classList.contains('is-hidden')) {
      selectWrap.classList.remove('is-hidden');
      selectInput.focus();
      return;
    }

    var variantId = (selectInput && selectInput.value) || (hiddenInput && hiddenInput.value);
    if (!variantId) { alert('Please select a variant first'); return; }

    addBtn.disabled = true;
    var originalText = addBtn.innerHTML;
    addBtn.innerHTML = 'Adding...';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error(await res.text());

      addBtn.innerHTML = '✓ Added!';
      addBtn.classList.add('added');
      setTimeout(function () {
        addBtn.innerHTML = originalText;
        addBtn.disabled = false;
        addBtn.classList.remove('added');
        if (selectWrap && !selectWrap.classList.contains('is-hidden')) {
          selectWrap.classList.add('is-hidden');
        }
      }, 2000);

      showCartToast('Added to Cart!');
      var cart = await fetchCart(true);
      updateCartBubble(cart.item_count);
      if (window.Shopflo && typeof window.Shopflo.refreshCart === 'function') window.Shopflo.refreshCart();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

    } catch (err) {
      console.error('[REEL ATC]', err);
      addBtn.disabled = false;
      addBtn.innerHTML = originalText;
      alert('Failed to add to cart. Please try again.');
    }
  }, true);

  rootEl.addEventListener('change', async function (e) {
    var selectInput = e.target.closest('select[name="id"]');
    if (!selectInput || !selectInput.hasAttribute('data-reel-variant-select')) return;
    var form       = selectInput.closest('.reel-product-form');
    var addBtn     = form && form.querySelector('.reel-atc-button');
    var selectWrap = form && form.querySelector('.reel-variant-select');
    if (selectWrap && !selectWrap.classList.contains('is-hidden') && addBtn) addBtn.click();
  });

  // ── Cart helpers ────────────────────────────────────────────────────────────

  async function fetchCart(force) {
    if (cartCache && !force) return cartCache;
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) throw new Error('cart fetch failed');
      cartCache = await res.json();
      return cartCache;
    } catch (e) {
      return { items: [], item_count: 0, total_price: 0 };
    }
  }

  function updateCartBubble(count) {
    var bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
    if (bubble) {
      bubble.textContent = count;
    } else {
      var icon = document.querySelector('.header__icon--cart');
      if (icon) {
        var b = document.createElement('div');
        b.className = 'cart-count-bubble flo-cart-icon-bubble';
        b.textContent = count;
        icon.appendChild(b);
      }
    }
  }

  function showCartToast(message) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message || 'Added to Cart!';
    toast.classList.remove('show');
    void toast.offsetWidth;
    toast.classList.add('show');
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () { if (toast.parentNode) toast.remove(); }, 300);
    }, 2500);
  }

  fetchCart().then(function (cart) { updateCartBubble(cart.item_count); });
}
